export default {
  'component': {
    'tradeInProcess': {
      '649f8aefats0': 'Bestellzeit abgelaufen',
      '649f8aefc1c0': 'Recycling fehlgeschlagen',
      '649f8aefc9c0': 'Neues Angebot anfordern',
      'TradeIn': 'Trade-In-Vorgang',
      'logistic': 'Versandetikett herunterladen',
      'start': 'Jetzt starten',
      'success': 'Du hast das neue Gerät erfolgreich erhalten',
      'qc': 'Qualitätsprüfung des Altgeräts',
      'business': 'Wir werden die Prüfung deines Altgeräts innerhalb von 3 Werktagen abschließen',
      'completed': 'Abgeschlossen',
      'successfully': 'Glückwunsch – dein Trade-In war erfolgreich',
      'orderInfor': 'Bestellinformationen',
      'orderID': 'Trade-In-Bestellnummer',
      'orderNum': 'Bestellnummer des neuen Geräts',
      'createTime': 'Erstellungsdatum',
      'brand': 'Geschätzte Marke',
      'model': 'Geschätztes Modell',
      'price': 'Preis des Altgeräts',
      'bonus': 'Bonus',
      'reclaimFailure': 'Da du dein Gerät nicht innerhalb von 10 Tagen versendet hast, wurde deine Recycling-Bestellung automatisch storniert. Wenn du die Recycling-Anfrage fortsetzen möchtest, kannst du unten auf die Schaltfläche klicken, um den aktuellsten Preis zu prüfen.',
      'total': 'Gesamtpreis',
      'logisticInfo': 'Versandinformationen',
      'available': 'Keine Versandinformationen verfügbar',
      'logisticNum': 'Sendungsnummer',
      'failRey': 'Es tut uns leid, dass deine Teilnahme am OnePlus-Recycling-Programm nicht erfolgreich abgeschlossen werden konnte. Wenn du weitere Elektronikgeräte recyceln möchtest, klicke unten für eine schnelle Schätzung!',
      'userRes': 'Der Nutzer hat das Angebot bereits abgelehnt.',
      'successPrice': 'Der folgende Preis basiert auf einer professionellen Prüfung. Wenn du mit diesem Preis einverstanden bist, kannst du den Trade-In abschließen. Wenn du ihn ablehnst, wird dein Gerät innerhalb weniger Werktage zurückgesendet.',
      'sure': 'Akzeptieren',
      'Reject': 'Ablehnen',
      'congratulation': 'Glückwunsch – keine Abweichungen bei der Qualitätsprüfung!',
      'finPirce': 'Endpreis',
      'copySuccess': 'Kopieren erfolgreich',
      'copyfail': 'Kopieren fehlgeschlagen',
      'sureSuccess': 'Transaktion erfolgreich bestätigt',
      'submitError': 'Übermittlung fehlgeschlagen',
      'detectionResult': 'Prüfergebnis',
      'Collected': 'Bestellung aufgeben',
      'inTransit': 'Unterwegs',
      '656g0lj3sav6': 'Recyclingprozess',
      '656g0lj3cd5a': 'Gib deine persönlichen Daten korrekt ein und schließe die Bestellung erfolgreich ab',
      '656g0lj3dr9a': 'Die Prüfung deines Smartphones wird innerhalb von 48 Stunden nach Eingang in unserem Zentrum abgeschlossen.',
      '656g0lj3epal': 'Sobald die Prüfung abgeschlossen ist, erhältst du unser endgültiges Angebot per E-Mail.',
      '656g0lj3pda2': 'Deine Schätzung',
      '656g0lj3ed3d': 'Professionelle Qualitätsprüfung',
      '656g0lj3esf3': 'Kopieren',
      'expertDiscount': 'Aktionscode',
      'invalidCode': 'Ungültiger Code',
      'toastTip': 'Bestätige, dass du die Datenschutzerklärung und Nutzungsbedingungen akzeptierst.',
      '649f8aef26sf': 'Trade-In-Prozess',
      'checkTitle': 'Testinformationen',
      'basicInformation': 'Basisinformationen',
      'understand': 'Ich verstehe'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Recycling ablehnen',
      '64a9shqq3k00': 'Du bestätigst, dass du das Recycling ablehnst',
      '64a9shqq3r00': 'Stornierung erfolgreich',
      '64a9shqq3ws0': 'Stornierung fehlgeschlagen',
      'sureCancel': 'Stornierung bestätigen'
    }
  },

  'home': {
    'whoAreWe': {
      '646u995ltgw0': 'Wer',
      '646u995lv9g0': 'sind wir?',
      '646u9d5lv9g0': 'Danghuan ist ein Unternehmen, das sich auf das Recycling, die Entsorgung und den Verkauf von 3C-Digitalprodukten wie Mobiltelefonen, Tablets, Laptops und Smartwatches spezialisiert hat. Unser Unternehmen engagiert sich dafür, die Recyclingeffizienz von Elektronikprodukten zu steigern und die gesunde Entwicklung des Gebrauchtmarkts zu fördern. Derzeit haben wir offizielle strategische Partnerschaften mit OPPO, Vivo, OnePlus, Realme und weiteren Marken aufgebaut. Unser internationales Geschäft hat sich auf Indien, Thailand, Vietnam, Kambodscha und nun auch auf Europa ausgeweitet.',
      '646u995dv9g0': 'Dank unserer globalen Präsenz sind wir ein strategischer Partner für Mobilfunkanbieter, Hersteller und Großhändler – sowohl auf kontinentaler als auch auf internationaler Ebene.',
      '646u99slv9g0': 'Wir arbeiten mit führenden Herstellern zusammen und führen ein vielfältiges Sortiment an Geräten der Einsteiger-, Mittel- und Oberklasse. So können wir maßgeschneiderte Lösungen und wettbewerbsfähige Preise anbieten, um die Anforderungen unserer Kunden zu erfüllen.'
    },
    'business': {
      '646v04syvpk0': 'Interessiert an unserem Lagerbestand?',
      '646v04syxs80': 'Bei Danghuan bieten wir eine große Auswahl an Smartphones, Tablets und Smartwatches in verschiedenen Qualitätsstufen, um unterschiedliche Geschäftsanforderungen zu erfüllen.',
      '646v04syy6g0': 'Kontaktiere unseren Vertriebs- und Einkaufsleiter:',
      '646v04syya80': 'Ich möchte kaufen',
      '646v04syydg0': 'Name eingeben',
      '646v04syyh40': 'Telefonnummer eingeben',
      '646v04syyyw0': 'E-Mail-Adresse eingeben',
      '646v0gsyz1s0': 'Land:',
      '646v04syz1s0': 'Bitte wähle eine Option aus',
      '646v04syz4o0': 'Ich habe gelesen und akzeptiere die',
      '646v04syzkc0': 'Datenschutzerklärung',
      '646v04syzok0': 'Kontaktiere uns',
      '646v04syzvo0': 'Bitte gib deine Telefonnummer ein.',
      '646v04syzys0': 'Bitte gib deine E-Mail-Adresse ein.',
      '646v04sz01o0': 'Bitte gib eine gültige E-Mail-Adresse ein.',
      '646v04sz04g0': 'Bitte gib deinen Namen ein.',
      '646v04sz0740': 'Bitte bestätige, dass du die Datenschutzbestimmungen akzeptierst.',
      '646v04sz0a00': 'Übermittlung erfolgreich',
      '646v04sz0cw0': 'Übermittlung fehlgeschlagen',
      'title1': 'Transparente Geräteeinstufung',
      'text1-1': 'Zur Unterstützung deiner Kaufentscheidung empfehlen wir, unser detailliertes Einstufungsdokument zu lesen.',
      'title2': 'Hervorragender Kundensupport',
      'text2-1': 'Wir erkennen die individuellen Bedürfnisse jedes Kunden und deshalb engagiert sich unser mehrsprachiges Vertriebsteam, um maßgeschneiderte und fachkundige Unterstützung zu bieten.',
      'title3': 'Engagement für nachhaltige Technologie',
      'text3-1': 'Wir setzen uns für den weltweiten Zugang zu nachhaltigen Technologielösungen ein und schaffen dabei Mehrwert für alle Beteiligten.',
      'text3-2': 'Für weitere Anfragen oder zur Vereinbarung einer Testbestellung kontaktiere uns bitte. Unser Team steht dir mit Professionalität und Sorgfalt zur Seite.'
    }
  },
  'components': {
    'section2': {
      '646tj9dnkk00': 'Erhalte deine Zahlung in nur 4 einfachen Schritten',
      's1': 'Erster Schritt',
      's1t': 'Verpacke dein Gerät sorgfältig, damit es in demselben Zustand ankommt, in dem du es versendet hast.',
      's2': 'Zweiter Schritt',
      's2t': 'Gib dein Paket an einem unserer Abgabepunkte ab.',
      's3': 'Dritter Schritt',
      's3t': 'Wir prüfen dein Gerät und erstellen ein passendes Angebot.',
      's4': 'Vierter Schritt',
      's4t': 'Erhalte deine Zahlung schnell und unkompliziert.'
    },
    'section3': {
      '646tmse2fbo0': 'Smartphones',
      '646tmse2mv00': 'Bleib dran',
      'section3-text2': 'Tablets',
      'section3-text4': 'Smartwatches',
      'section3-text5': 'Andere Geräte',
      'title': 'Schnelle Wertermittlung',
      't1': 'Wähle den Gerätetyp aus und starte die Bewertung, um ein faires Angebot zu erhalten.',
      't2': 'Einfache Schritte – nutze unseren schnellen Recycling-Service!'
    },
    'section6': {
      '646txzpazuc0': 'Über Danghuan',
      '666txzpazuc0': 'Ein Unternehmen, das sich auf das Recycling und die Wiederverwendung von Smartphones, Tablets und anderen digitalen Geräten spezialisiert hat – mit dem Ziel, einen einfachen, sicheren und effizienten Service anzubieten, damit jeder Kunde sein Altgerät mühelos recyceln kann.',
      '646txzpb0rk0': 'Details',
      '646txzpb0xc0': 'Recycling-Service für 12 Marken'
    },
    'section7': {
      '646ns2k5f7k0': 'Unser Service ist jederzeit verfügbar',
      '646ns2k5gmw0': 'Kundendienst: Montag bis Freitag von 9:00 bis 18:00 Uhr CET (UTC+1:00), Madrid, Spanien',
      '646ns2k5gs40': 'Name eingeben',
      '646ns2k5gx40': 'Telefonnummer eingeben',
      '646ns2k5img0': 'E-Mail-Adresse eingeben',
      '646ns2k5isw0': 'Schreib uns eine Nachricht, bevor wir dich kontaktieren.',
      '646ns2k5iws0': 'Kontaktiere uns',
      '646ns2k5j140': 'Bitte gib deine Telefonnummer ein.',
      '646ns2k5j4g0': 'Bitte gib deine E-Mail-Adresse ein.',
      '646ds2k5j4g0': 'E-Mail',
      '646ns2k5j6c0': 'Bitte gib eine gültige E-Mail-Adresse ein.',
      '646ns2k5j8g0': 'Kontaktiere uns',
      '646ns2k5jak0': 'C.I.F :',
      '646ns2k5jck0': 'Adresse',
      '646ns2s5jck0': 'Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Spanien',
      '646ns2k5jgc0': 'Bitte gib deinen Namen ein.',
      '646ns2k5ji40': 'Bitte bestätige, dass du die Datenschutzerklärung akzeptierst.',
      '646ns2k5jk00': 'Übermittlung erfolgreich',
      '646ns2k5jm80': 'Übermittlung fehlgeschlagen',
      '646ny1rgz3c0': 'Ich habe gelesen und akzeptiere die ',
      '646ny1rh2k40': 'Datenschutzerklärung'
    },
    'successMain': {
      // '647qmd42l1s0': 'Bestellung erfolgreich eingegangen!',
      '647qmd42l1s0': '✅ Bestellung erfolgreich eingegangen!',
      '647qmd42mss0': 'Bitte achte auf die Versandanweisungen, die dir per E-Mail von no-reply@danghuan.eu zugesendet werden. Falls du keine E-Mail erhalten hast, überprüfe bitte deinen SPAM-Ordner oder kontaktiere unseren Kundenservice unter oneplus@danghuan.eu.',
      '647qmd42mz80': 'Unser Angebot',
      '647qmd42yeo0': 'Tipps vor dem Versand',
      'orderTime': 'Bestellzeitpunkt',
      'text1': 'Kostenloser Versand',
      'text2': 'Bitte beachte die Versanddokumente, die an deine E-Mail-Adresse gesendet wurden.',
      'text3': 'Datensicherung',
      'text4': 'Zum Schutz deiner Daten sichere bitte alle Inhalte und setze das Gerät anschließend zurück oder lösche alle Daten.',
      'text5': 'Ladevorgang',
      'text6': 'Bitte lade dein Gerät mindestens zu 1 %, bevor du es versendest. Das beschleunigt die Überprüfung.',
      'downloadDec': 'Bitte laden Sie die Integritätserklärung herunter.',
      // 奥地利线下
      '647qmd42sd6v': '📩 Überprüfen Sie Ihre E-Mail (no-reply@danghuan.eu) für die Versandanweisungen. Falls Sie sie nicht finden, kontaktieren Sie bitte: <b>vivo-at@danghuan.eu</b>',
      '647qmd42d6a3': '💰 Sichern Sie sich einen Bonus von <b style=\'color: #FF9500; font-size: 18px\'>50 €</b> nach Abschluss des Trade-in-Prozesses!',
      '647qmd42s6q6': '<b style=\'color: #405fff\'> ⚠️ Der Bonus wird zusammen mit dem Rückkaufwert des Geräts ausgezahlt, sobald ein neues vivo-Gerät gekauft wurde.</b>',
      // 奥地利线上
      '647qmd4226s3': '💥 Sichern Sie sich einen exklusiven Rabatt für die Teilnahme am Trade-In-Programm!',
      '647qmd42dx9w': '💰 Verwenden Sie ihn auf <b style=\'color: #405fff\'>vivo-official.com</b>',
      '647qmd42dv6x': '📅 Gültig bis zum <b style=\'color: #405fff\'>31/05/2026</b>',
      '647qmd42d5v6': '🔑  Code: RETURNX300 💰100 EUR Rabatt → ',
      '647qmd42vrh6': '🔑  Code: RETURN100 💰100 EUR für X300&X300Pro → ',
      '647qmd42r6q9': '🔑  Code: RETURN50 💰50 EUR für vivo V70 → ',
      '647qmd42q9v6': '🔑  Code: RETURNV70 💰50 EUR Rabatt → ',
      '647qmd4es6v6': '⚠️ Gilt nur für die jeweils zugewiesenen spezifischen Produkte.',


      '647qmd42dv6f': 'Si no lo encuentras, contacta: <b> support@danghuan.eu </b>',
      '647qmd42xsv3': '🎁 Consigue un <b>12% de descuento extra</b> por participar en el programa de canje. ',
      '647qmd42gc5e': '🎁 <b>12% de descuento extra</b> por canje.',
      '647qmd42fx9q': '💰 Úsalo en <b style=\'color: #405fff\'>vivoonlinestore.com</b> al finalizar tu compra.',
      'promotionCode': '🔑 <b>Code:</b> ',
      'copy': 'Code kopieren',
      '647qmd42rd5g': '📅 Válido hasta el <b>31/12/2025.</b>',
      '647qmd42f3d2': '📅 Válido hasta el <b>31/12/2025.</b>',
      '647qmd42d5a6': '💥 ¡Consigue un descuento exclusivo por participar en el programa de canje!',
      '647qmd42d1st': '🔹 Para <b>vivo X300 PRO Bundle</b>', // 新增
      // "647qmd426eg9": "💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>250 €</b> de descuento directo.", // 新增
      '647qmd426eg9': '💰 Úsalo en <b>vivoonlinestore.com</b> y obtén un <b>12%</b> de descuento extra.',
      '647qmd42s6f2': '📅 Válido hasta el <b>30/06/2026.</b>', // 新增
      '647qmd42d3e2': '🔹 Para <b>vivo X300</b>',
      '647qmd42ey6q': '💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>100 €</b> de descuento directo.',
      '647qmd42fd26': '💰 Úsalo en <b>vivoonlinestore.com</b> y obtén <b>50 €</b> de descuento directo.',
      '647qmd423q6e': '🔹 Para otros modelos',
      '647qmd42uq3c': '💰 Úsalo en <b>vivoonlinestore.com</b> y obtén un <b>12%</b> de descuento extra.',
      '647qmd4eq3f6': '🔹 Para <b>vivo X300 PRO</b>',
      '647qmd4ee3qt': '⚠️ Los códigos de cupón no son acumulables.'
    },
    'tradeInProcess': {
      '649f8aefats0': 'Bestellzeit abgelaufen',
      '649f8aefc1c0': 'Recycling fehlgeschlagen',
      '649f8aefc9c0': 'Neues Angebot anfordern',
      'TradeIn': 'Trade-In-Vorgang',
      'logistic': 'Versandetikett herunterladen',
      'start': 'Jetzt starten',
      'success': 'Du hast das neue Gerät erfolgreich erhalten',
      'qc': 'Qualitätsprüfung des Altgeräts',
      'business': 'Wir werden die Prüfung deines Altgeräts innerhalb von 3 Werktagen abschließen',
      'completed': 'Abgeschlossen',
      'successfully': 'Glückwunsch – dein Trade-In war erfolgreich',
      'orderInfor': 'Bestellinformationen',
      'orderID': 'Recycling-Bestellnummer',
      'orderNum': 'Bestellnummer des neuen Geräts',
      'createTime': 'Erstellungsdatum',
      'brand': 'Geschätzte Marke',
      'model': 'Modell',
      'price': 'Preis des Altgeräts',
      'bonus': 'Bonus',
      'total': 'Gesamtpreis',
      'logisticInfo': 'Versandinformationen',
      'available': 'Keine Versandinformationen verfügbar',
      'logisticNum': 'Sendungsnummer',
      'failRey': 'Es tut uns leid, dass deine Teilnahme am OnePlus-Recycling-Programm nicht erfolgreich abgeschlossen werden konnte. Wenn du weitere Elektronikgeräte recyceln möchtest, klicke unten für eine schnelle Schätzung!',
      'userRes': 'Der Nutzer hat das Angebot bereits abgelehnt.',
      'successPrice': 'Der folgende Preis basiert auf einer professionellen Prüfung. Wenn du mit diesem Preis einverstanden bist, kannst du den Trade-In abschließen. Wenn du ihn ablehnst, wird dein Gerät innerhalb weniger Werktage zurückgesendet.',
      'sure': 'Akzeptieren',
      'Reject': 'Ablehnen',
      'congratulation': 'Glückwunsch – keine Abweichungen bei der Qualitätsprüfung!',
      'finPirce': 'Endpreis',
      'copySuccess': 'Kopieren erfolgreich',
      'copyfail': 'Kopieren fehlgeschlagen',
      'sureSuccess': 'Transaktion erfolgreich bestätigt',
      'submitError': 'Übermittlung fehlgeschlagen',
      'detectionResult': 'Prüfergebnis',
      'Collected': 'Abgeholt',
      'inTransit': 'Unterwegs / Versand',
      'understand': 'Ich verstehe',
      '656g0lj3sf6e': 'Die Aktionsboni werden von den jeweiligen Partnermarken angeboten und verwaltet. Sie werden separat ausgezahlt und sind nicht Teil der Bewertung des Altgeräts.'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Recycling ablehnen',
      '64a9shqq3k00': 'Du bestätigst, dass du das Recycling ablehnst',
      '64a9shqq3r00': 'Stornierung erfolgreich',
      '64a9shqq3ws0': 'Stornierung fehlgeschlagen',
      'sureCancel': 'Stornierung bestätigen'
    }
  },
  'shippingLable': {
    'shippingLable': {
      'firstStep': 'Persönliche Daten',
      '649fhwp9zbo0': 'Lade ein klares Foto deines Pakets hoch.',
      '649fhwpa1900': 'Versandetikett herunterladen',
      '649fhwpa1l00': 'Versandetikett herunterladen',
      '649fhwpa1tc0': 'Lieferung abschließen',
      '649fhwpa2100': 'Paketfoto und Ehrlichkeitserklärung',
      '649fhwpa2880': 'Beispiel zur Platzierung des Versandetiketts',
      '649fhwpa2h80': 'Hinweis',
      '649fhwpa2qk0': 'Verpackung: Wickle das Telefon in Luftpolsterfolie und fülle den Karton mit Papier aus, um Transportschäden zu vermeiden.',
      '649fhwpa2xs0': 'Fülle Lücken mit Polstermaterial, um Schäden zu vermeiden.',
      '649fhwpa3fk0': 'Logistiketikett: Bringe das digitale oder gedruckte Etikett zur Abgabestelle, wo das offizielle Label gedruckt wird.',
      '649fhwpa3v40': 'Bitte sende dein Altgerät so bald wie möglich ein. Wenn es nicht innerhalb von 10 Tagen versendet wird, wird die Bestellung storniert.',
      '649fhwpa42s0': 'Abgabestellen suchen',
      '649fhwpa4as0': 'Label herunterladen',
      '649fhwpa4jo0': 'Hochladen',
      '649fhwpa4ok0': 'Startseite',
      '649fhwpa4to0': 'Erfolgreich eingereicht',
      '649fhwpa4yk0': 'Herzlichen Glückwunsch, der Download war erfolgreich!',
      '649fhwpasf3s': 'Achtung',
      '649fhwpaa6f3': 'Bitte drucke die Ehrlichkeitserklärung aus, unterschreibe sie, fotografiere sie zusammen mit dem Paket und lade das Foto hoch.'
    }
  },
  'bottom': {
    'index': {
      '646d51qugz40': 'Soziale Medien',
      '646d71qugz40': 'Einfache Zahlung',
      '646u51qugz40': 'Logistik',
      '646u5dqui780': 'Datenschutzerklärung',
      '646uddqui780': 'Allgemeine Geschäftsbedingungen (AGB)',
      '646u51qui780': 'Häufig gestellte Fragen (FAQ)'
    }
  },
  'head': {
    'index': {
      '646nt7hwh0c0': 'Über Danghuan',
      '646ntjwmn580': 'Geschäft',
      '646nt7hwils0': 'Kontaktiere uns',
      '646nt7hwipg0': 'Kaufen',
      '646nt7hwis00': 'Verkaufen'
    }
  },
  'PCModelList': {
    'index': {
      '646wfv5g0ro0': 'Kostenlose Schätzung'
    }
  },
  'PCSearch': {
    'index': {
      '646wgb1ni8k0': 'Gib das Modell ein, das du verkaufen möchtest.',
      '646wgb1nj8o0': '搜索词',
      '646wgb1nji80': '我触发搜索上拉了',
      'empty': 'Entschuldigung, dieses Modell ist nicht verfügbar.',
      'confirm': 'Bestätigen',
      'cancle': 'Abbrechen',
      'dialogText': 'Bist du sicher, dass du den gesamten Verlauf löschen möchtest Einträge?'
    }
  },
  'PCProduct': {
    'empty': 'Entschuldigung, dieses Modell ist nicht verfügbar.'
  },
  'PCBrandTab': {
    'index': 'Marke'
  },
  'PCCategoryTab': {
    'index': 'Kategorie'
  },
  'PCOrderStep': {
    'index': {
      '646xagqwff40': 'Online bestellen',
      '646xagqwkuw0': 'Kostenloser Versand',
      '646xagqwmao0': 'Prüfung',
      '646xagqwmlc0': 'Schnelle Auszahlung'
    }
  },
  'PCBreadNav': {
    'index': {
      '646xgup6ugg0': 'Startseite'
    }
  },
  'router': {
    'selectModel': 'Modelle',
    'selectProperty': 'Geräteprobleme',
    'price': 'Geschätzter Preis',
    'priceOrder': 'Bestellung aufgeben',
    'orderSuccess': 'Bestellung erfolgreich'
  },
  'PCDeviceInfo': {
    'index': {
      '646ymq6orm00': 'Modell erneut auswählen',
      '646ymq6ot0k0': 'Erinnerung',
      '646ymq6pd100': 'Bitte stelle vor dem Versand sicher, dass du dich aus deinem Cloud-Konto abgemeldet hast',
      '646ymq6pekw0': '/Bildschirmsperre / Apple ID auf dem alten Gerät.'
    }
  },
  'PCModelInfo': {
    'index': {
      '646yn085ljk0': 'Gerätezustand auswählen',
      '647h1f4yr6c0': 'Geschätzter Preis',
      '647h1f4yso80': 'Geschätzter Bonus',
      'text1': 'Kostenloser Versand',
      'text2': 'Wir bieten einen kostenlosen Logistik- und Versandservice an.',
      'text3': 'Sofortige Auszahlung',
      'text4': 'Die Auszahlung erfolgt innerhalb von 3 Werktagen, sobald wir dein gebrauchtes Gerät erhalten haben.',
      '64tve23zt0g0': 'Kostenloser Versand und Versandpaket',
      '64tve23zup00': 'Sichere Datenlöschung',
      '64tve23zuy40': 'Nicht zufrieden? Kostenlose Rücksendung.',
      '64tve23zv7g0': 'Die Zahlung wird innerhalb von 3 Werktagen nach Erhalt des Geräts veranlasst.',
      '64tve23zvbg0': 'Wähle deine Versandmethode',
      '64tve23zvf80': 'Du hast 10 Tage Zeit, um dein Smartphone zu versenden.',
      '64tve23zvjc0': 'Erhalte ein kostenloses Versandetikett und sende dein Gerät ein.',
      '64tve23zvms0': 'Das Versandetikett wird dir per E-Mail zugesandt.',
      '64tve23zvqg0': 'Hinweis:',
      '64tve23zvyo0': 'Aufgrund von Versandbestimmungen zu Lithiumbatterien darfst du das Gerät nicht einsenden, wenn du vermutest, dass der Akku defekt ist.',
      '64tve23zwak0': 'Mitgesendetes Zubehör oder Verpackungen können leider nicht zurückgesendet werden.',
      '64tve23zwgs0': 'Nächste Schritte, um dein Smartphone zu verkaufen',
      '64tve23zwm80': 'Gib deine Kontaktdaten ein',
      '64tve23zwt00': 'Bereite dein Smartphone für den Versand vor',
      '64tve23zwwk0': 'Dein Gerät wird nach Eingang überprüft. Sollten deine Angaben nicht korrekt sein, senden wir dir ein neues Angebot. Du kannst das neue Angebot annehmen oder dein Gerät kostenlos zurückerhalten.'
    }
  },
  'PCPropertyList': {
    'index': {
      '646ynp3udds0': '购买渠道',
      '646ynp3ueas0': '需要激活，无法正常通话',
      '646ynp3uehw0': 'Gib die IMEI-Nummer ein',
      '646ynp3uem40': 'Wähle *#06# auf der Tastatur, um die IMEI deines Geräts zu prüfen.'
    }
  },
  'PCButton': {
    'index': {
      '646zhxujd5g0': 'Angebot ansehen'
    }
  },
  'PCBottomButton': {
    'index': {
      '647hqss75ac0': 'Hinweis: Die Preise für Mobiltelefone und Elektronik können um bis zu 6 % sinken – wir empfehlen daher, dein Paket so bald wie möglich zu versenden.',
      '647hqss760c0': 'Ich habe gelesen und akzeptiere die',
      '647hqss764w0': 'Datenschutzerklärung',
      '647hqss76ac0': 'Allgemeine Geschäftsbedingungen',
      '647hqss76dg0': 'Absenden',
      '647hqss76gw0': 'Gesamtbetrag',
      'text1': 'Gesamtbetrag',
      'text2': 'Geschätzter Preis',
      'text3': 'Geschätzter Bonus',
      'dialogTitle': 'Hinweis',
      'dialogText': 'Klicke auf BESTÄTIGEN und prüfe deine E-Mails, um mit dem nächsten Schritt fortzufahren.',
      'dialogBtn': 'BESTÄTIGEN',
      'settleaccountBtn': 'Bestellung bestätigen'
    }
  },
  'PCUserInfo': {
    'index': {
      '647kboa03ks0': 'Bestellinformationen',
      '647kboa06ys0': 'Name',
      '647kboa0d6v8': 'Ländercode',
      '647kboa078s0': 'Telefon',
      '647kboa07d00': 'Adresse',
      '647kboa07jk0': 'Land',
      '647kboa07p80': 'Bitte auswählen',
      '647kboa08b40': 'Postleitzahl',
      '647kboa08h00': 'Stadt',
      '647kboa08zc0': 'Adresse',
      '647kboa09440': 'Bankverbindung',
      '647kboa096w0': 'E-Mail-Verifizierung',
      '647kboa09ao0': 'E-Mail',
      '647kboa09dk0': 'Verifizierungscode',
      '647kboa05s1d': 'Eingeben',
      '647kboa09u40': 'Eingeben',
      '647kboa09z80': 'Senden',
      '647kboa0ak00': 'E-Mail-Format fehlerhaft',
      '647kboa0aog0': 'Erfolgreich gesendet',
      'send': 'Gesendet',
      'submit': 'Absenden',
      'error': 'Falscher Verifizierungscode',
      '64jjt96fg400': 'Bitte gib den Verifizierungscode ein',
      '64jjt96fki00': 'Bitte hole den Verifizierungscode ein',
      'idNumber': 'Personalausweisnummer / ID-Nummer',
      'declaration': 'Ehrlichkeitserklärung',
      'download': 'Herunterladen',
      '647kboa0idc0': 'Persönliche ID',
      '647kboa0idc1': '(die offizielle Identifikationsnummer, die von deinem Land ausgestellt wurde, die für rechtliche, steuerliche oder verwaltungstechnische Zwecke verwendet wird. Dies kann deine DNI, NIE, Steuernummer Personalausweisnummer oder CNP, oder ein anderes gleichwertiges nationales Dokument, abhängig von deinem Wohnsitzland.)',
      '647kboa0idc2': '(die offizielle Identifikationsnummer, die von deinem Land ausgestellt wurde, die für rechtliche Zwecke verwendet wird, steuerliche oder verwaltungstechnische Verfahren. Dies kann deine DNI, NIE, Steuernummer, Personalausweisnummer oder CNP sein, oder ein anderes gleichwertiges nationales Dokument, abhängig von deinem Wohnsitzland.)',
      'idError': 'Ungültige ID-Nummer',
      'ibanTip': 'Wird für den Zahlungseingang des Altgeräts verwendet.',
      'addreddPlaceholder': 'Dieses Feld unterstützt bis zu 105 Zeichen'
    }
  },
  'successOrder': {
    'successOrder': {
      '647s39cv77s0': 'Startseite',
      'notRecyclable': 'Dieser Gerätetyp ist nicht recyclingfähig.',
      'IKnow': 'Verstanden',
      'tips': 'Tipps'
    }
  },

  'blog': {
    'blogList': {
      '64wgr171lsk0': 'Aufrufe',
      '64wgr171nq40': 'Keine relevanten Inhalte verfügbar.',
      '64wgr171av65': 'Datum'
    },
    'blogDetail': {
      '64wgr9y5r7s0': 'Aufrufe',
      '64wgr171wdx9': 'Details'
    }
  },

  'cookieNotice': {
    'title': 'Cookie-Hinweis',
    'description': 'Wir verwenden Cookies, um dein Nutzungserlebnis zu verbessern. Durch die weitere Nutzung dieser Website stimmst du unserer',
    'cookiePolicy': 'Cookie-Richtlinie zu.',
    'acceptAll': 'Alle Cookies akzeptieren',
    'acceptNecessary': 'Nur notwendige Cookies akzeptieren',
    'customize': {
      'title': 'Bitte wähle die Arten von Cookies aus, die du akzeptieren möchtest:',
      'necessary': {
        'label': 'Erforderliche Cookies',
        'description': 'Diese Cookies sind für die Funktion der Website unerlässlich und können nicht deaktiviert werden.'
      },
      'analytics': {
        'label': 'Analyse-Cookies',
        'description': 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren.'
      },
      'marketing': {
        'label': 'Marketing-Cookies',
        'description': 'Diese Cookies verfolgen die Nutzeraktivität über verschiedene Websites hinweg, um relevante Werbung bereitzustellen.'
      }
    },
    'save': 'Einstellungen speichern',
    'cancel': 'Abbrechen'
  }
}